import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery, useMutation } from "react-apollo";
import { Tag, Title, Tab, Field, Control, Button, Icon } from "rbx";
import {
  Link,
  Route,
  useParams,
  useHistory,
  useLocation,
  Switch
} from "react-router-dom";

import Loading from "../../../components/Loading";

import {
  SINGLE_VENDOR_QUERY,
  UPDATE_VENDOR_MUTATION,
  DELETE_VENDOR_MUTATION
} from "../../../graphql/Vendors/Vendors.graphql";

import Details from "./routes/Details";
import IconLink from "../../../components/IconLink";

import { DeleteButton } from "../../../components/inputs";
import { getUTCFormattedDate, ourToast as toast } from "../../../utils";

const INITIAL_STATE = {
  VendorNo: "",
  Name: "",
  Active: "",
  Address1: "",
  Address2: "",
  City: "",
  State: "",
  Zip: "",
  Contact: "",
  Telephone: "",
  Fax: "",
  EmailAddr: "",
  WebSite: "",
  LastTransactionDate: ""
};

const VendorPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const { data } = useQuery(SINGLE_VENDOR_QUERY, {
    variables: { where: { RecId: parseInt(id) } }
  });
  const [updateVendor, { loading }] = useMutation(UPDATE_VENDOR_MUTATION, {
    refetchQueries: ["ALL_VENDORS_QUERY", "SINGLE_VENDOR_QUERY"]
  });

  const [editing, setEditing] = useState(true);
  const [inputs, setInputs] = useState({ ...INITIAL_STATE });

  useEffect(() => {
    if (data?.Vendor) {
      setInputs(data.Vendor);
    }
  }, [data]);

  const toggleEditing = () => setEditing(!editing);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };

  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateVendor({
        variables: {
          data: {
            ...obj,
            LastTransactionDate: obj.LastTransactionDate
              ? getUTCFormattedDate(obj.LastTransactionDate)
              : null
          },
          where: { RecId: parseInt(id) }
        }
      });
      setEditing(false);
      toast.success("Vendor updated successfully.");
    } catch (err) {
      toast.error("Error updating Vendor.");
    }
  };

  if (loading || !data?.Vendor) return <Loading />;
  const getActionButtons = () => {
    if (location.pathname.includes("details")) {
      return (
        <Field kind="group">
          <Control>
            <Button
              color="primary"
              disabled={editing}
              size="small"
              onClick={toggleEditing}
            >
              <Icon>
                <FontAwesomeIcon icon="edit" />
              </Icon>
              <span>Edit</span>
            </Button>
          </Control>
          <Control>
            <DeleteButton
              mutation={DELETE_VENDOR_MUTATION}
              refetchQueries={["ALL_VENDORS_QUERY", "SINGLE_VENDOR_QUERY"]}
              size="small"
              variables={{ where: { RecId: parseInt(id) } }}
              onComplete={() => history.push("/fleet/vendors")}
            />
          </Control>
          <Control>
            <Button
              color="success"
              disabled={!editing}
              size="small"
              onClick={handleSave}
            >
              <Icon>
                <FontAwesomeIcon icon="save" />
              </Icon>
              <span>Save</span>
            </Button>
          </Control>
        </Field>
      );
    }
  };
  return (
    <React.Fragment>
      <header className="page-head">
        <div className="page-head-start">
          <Title color="primary" size={1}>
            {inputs?.Name}
          </Title>
          <Tag color={inputs?.Active ? "success" : "danger"}>
            {inputs?.Active ? "ACTIVE" : "INACTIVE"}
          </Tag>
          <div className="page-head-start--subheader">
            <IconLink
              href={`tel:${inputs?.Telephone}`}
              icon="phone-alt"
              label={inputs?.Telephone}
            />
            <IconLink
              href={`tel:${inputs?.Fax}`}
              icon="fax"
              label={inputs?.Fax}
            />
          </div>
        </div>
        <div className="page-head-end">{getActionButtons(location)}</div>
      </header>
      <Tab.Group kind="boxed">
        <Tab
          active={location.pathname.includes("details")}
          as={Link}
          tabIndex="-1"
          to="details"
        >
          <span>Details</span>
        </Tab>
      </Tab.Group>
      <Switch>
        <Route path="/fleet/vendors/:id/details">
          <Details editing={editing} vendor={inputs} onChange={handleChange} />
        </Route>
      </Switch>
    </React.Fragment>
  );
};

VendorPage.propTypes = {};

export default VendorPage;
